var _defs, _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew212({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.5,13.28a7.5,7.5,0,0,1,15,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 2.72,
    x2: 8,
    y2: 5.72
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.5,
    y1: 5.14,
    x2: 12.97,
    y2: 7.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.5,
    y1: 5.14,
    x2: 3.03,
    y2: 7.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew212);
export default __webpack_public_path__ + "static/media/Symbolpack_New_212.d8615a3b825e4181eb4d193759c71a94.svg";
export { ForwardRef as ReactComponent };